export const HEADERS = [
  'HEADER.ID',
  'HEADER.NAME',
  'HEADER.DESCRIPTION',
  'HEADER.CREATED',
];
